import React, { useState, useEffect, useRef } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const toggleRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      toggleRef.current &&
      !toggleRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      <nav className="p-4 lg:p-0 sticky top-0 z-50" data-aos='fade-down'>
        <nav className="bg-opacity-50 backdrop-filter backdrop-blur-md p-4 shadow-lg shadow-white rounded-[300px] lg:rounded-none">
          <div className="container mx-auto flex justify-between items-center">
            <div className="flex items-center">
              <img src="/logo.webp" alt="Logo" className="h-16 md:h-20 lg:h-24 w-auto mr-3" />
            </div>
            <div className="hidden lg:flex space-x-6">
              <a href="/" className="text-white text-2xl hover:text-gray-300">Beranda</a>
              <a href="/Program" className="text-white text-2xl hover:text-gray-300">Program Kegiatan & Fasilitas</a>
              <a href="/Galeri" className="text-white text-2xl hover:text-gray-300">Galeri</a>
              <a href="/Donasi" className="text-white text-2xl hover:text-gray-300">Donasi</a>
              <a href="/Daftar" className="text-white text-2xl hover:text-gray-300">Pendaftaran</a>
            </div>
            <div className="lg:hidden">
              <button ref={toggleRef} onClick={toggleMenu} className="text-white focus:outline-none">
                <svg className="h-8" fill="none" stroke="currentColor" viewBox="4 -2 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}></path>
                </svg>
              </button>
            </div>
          </div>
        </nav>
      </nav>

      {isOpen && (
        <div
          ref={menuRef}
          className="fixed z-50 bottom-0 left-0 w-full backdrop-blur-lg bg-transparent bg-opacity-60 border-2 rounded-t-3xl transform transition-transform duration-300 translate-y-0"
        >
          <div className="flex flex-col space-y-8 px-20 py-8 rounded-2xl bg-blur font-bold">
            <a href="/" className="text-center text-white text-2xl md:text-3xl hover:text-cyan-700" onClick={toggleMenu}>Beranda</a>
            <a href="/Program" className="text-center text-white text-2xl md:text-3xl hover:text-cyan-700" onClick={toggleMenu}>Program Kegiatan & Fasilitas</a>
            <a href="/Galeri" className="text-center text-white text-2xl md:text-3xl hover:text-cyan-700" onClick={toggleMenu}>Galeri</a>
            <a href="/Donasi" className="text-center text-white text-2xl md:text-3xl hover:text-cyan-700" onClick={toggleMenu}>Donasi</a>
            <a href="/Daftar" className="text-center text-white text-2xl md:text-3xl hover:text-cyan-700" onClick={toggleMenu}>Pendaftaran</a>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
